import Constants from '../../Constants';
import * as actionTypes from '../../constants/actionTypes';
import { DELETE, GET, POST, PUT } from 'js/constants/requestMethods';
import { ACLQueryModeTypes, SearchFilterViews } from 'js/constants/visibilityFilters';
import { CALL_PRIVATE_API } from 'js/middleware/api';
import { setTotalItems, setTotalPages } from '../app';
import { serviceKeysSchema } from 'js/schemas/serviceKey';
import { addProcess, removeProcess } from 'js/actions';
import {
  ACTIVATE_SERVICE_KEY,
  DELETE_SERVICE_KEY,
  PAUSE_SERVICE_KEY,
  ROTATE_SERVICE_KEY,
} from 'js/constants/processTypes';

export function fetchAllServiceKeys() {
  return (dispatch: any) => {
    return dispatch({
      [CALL_PRIVATE_API]: {
        types: [
          actionTypes.GET_ALL_SERVICE_KEYS_REQUEST,
          actionTypes.GET_ALL_SERVICE_KEYS_SUCCESS,
          actionTypes.GET_ALL_SERVICE_KEYS_FAILURE,
        ],
        endpoint: '/service_keys',
        schema: [serviceKeysSchema],
        requestMethod: GET,
        aclQueryMode: ACLQueryModeTypes.MODE_COLLABORATOR.key,
        requestInfo: { view: SearchFilterViews.SERVICE_KEYS },
      },
    }).then((response: { totalPages: number; totalItems: number }) => {
      dispatch(setTotalPages(response.totalPages));
      dispatch(setTotalItems(response.totalItems));

      return response;
    });
  };
}

export type UpdateServiceKeyDataParam = {
  name?: string;
  description?: string;
};
export function updateServiceKey(serviceID: number, data: UpdateServiceKeyDataParam) {
  return (dispatch: any) => {
    return dispatch({
      [CALL_PRIVATE_API]: {
        types: [
          actionTypes.UPDATE_SERVICE_KEYS_REQUEST,
          actionTypes.UPDATE_SERVICE_KEYS_SUCCESS,
          actionTypes.UPDATE_SERVICE_KEYS_FAILURE,
        ],
        payload: data,
        requestMethod: PUT,
        schema: serviceKeysSchema,
        endpoint: `/service_keys/${serviceID}`,
        requestInfo: {},
      },
    });
  };
}

export function deleteServiceKey(serviceKeyID: number) {
  return (dispatch: any) => {
    dispatch(addProcess(DELETE_SERVICE_KEY, 'Deleting Service Key', { serviceKeyID }));

    return dispatch({
      [CALL_PRIVATE_API]: {
        types: [
          actionTypes.DELETE_SERVICE_KEY_REQUEST,
          actionTypes.DELETE_SERVICE_KEY_SUCCESS,
          actionTypes.DELETE_SERVICE_KEY_FAILURE,
        ],
        endpoint: `/service_keys/${serviceKeyID}`,
        requestMethod: DELETE,
        requestInfo: { id: serviceKeyID },
      },
    }).finally(() => {
      dispatch(removeProcess(DELETE_SERVICE_KEY, { serviceKeyID }));
    });
  };
}

export function rotateServiceKey(id: number) {
  return (dispatch: any) => {
    dispatch(addProcess(ROTATE_SERVICE_KEY, 'Rotating Service API Key', { id }));

    return dispatch({
      [CALL_PRIVATE_API]: {
        types: [
          actionTypes.ROTATE_SERVICE_KEY_REQUEST,
          actionTypes.ROTATE_SERVICE_KEY_SUCCESS,
          actionTypes.ROTATE_SERVICE_KEY_FAILURE,
        ],
        endpoint: `/service_keys/${id}/rotate`,
        schema: serviceKeysSchema,
        requestMethod: PUT,
        requestInfo: { id },
      },
    }).finally(() => {
      dispatch(removeProcess(ROTATE_SERVICE_KEY, { id }));
    });
  };
}

export function pauseServiceKey(id: number) {
  return (dispatch: any) => {
    dispatch(addProcess(PAUSE_SERVICE_KEY, 'Pausing Service API Key', { id }));

    return dispatch({
      [CALL_PRIVATE_API]: {
        types: [
          actionTypes.PAUSE_SERVICE_KEY_REQUEST,
          actionTypes.PAUSE_SERVICE_KEY_SUCCESS,
          actionTypes.PAUSE_SERVICE_KEY_FAILURE,
        ],
        endpoint: `/service_keys/${id}/pause`,
        schema: serviceKeysSchema,
        requestMethod: PUT,
        requestInfo: { id },
      },
    }).finally(() => {
      dispatch(removeProcess(PAUSE_SERVICE_KEY, { id }));
    });
  };
}

export function activateServiceKey(id: number) {
  return (dispatch: any) => {
    dispatch(addProcess(ACTIVATE_SERVICE_KEY, 'Activating Service API Key', { id }));

    return dispatch({
      [CALL_PRIVATE_API]: {
        types: [
          actionTypes.ACTIVATE_SERVICE_KEY_REQUEST,
          actionTypes.ACTIVATE_SERVICE_KEY_SUCCESS,
          actionTypes.ACTIVATE_SERVICE_KEY_FAILURE,
        ],
        endpoint: `/service_keys/${id}/activate`,
        schema: serviceKeysSchema,
        requestMethod: PUT,
        requestInfo: { id },
      },
    }).finally(() => {
      dispatch(removeProcess(ACTIVATE_SERVICE_KEY, { id }));
    });
  };
}

export function createServiceKey(data: { name: string; description: string }) {
  return (dispatch: any) => {
    return dispatch({
      [CALL_PRIVATE_API]: {
        types: [
          actionTypes.CREATE_SERVICE_KEY_REQUEST,
          actionTypes.CREATE_SERVICE_KEY_SUCCESS,
          actionTypes.CREATE_SERVICE_KEY_FAILURE,
        ],
        endpoint: '/service_keys',
        schema: serviceKeysSchema,
        requestMethod: POST,
        payload: data,
      },
    });
  };
}
